import { configureStore } from "@reduxjs/toolkit";
import isMobileReducer from "./reducers/isMobile";
import themeModeReducer from "./reducers/themeMode";
import pageTitleReducer from "./reducers/pageTitle";
import packIdReducer from "./reducers/packId";
import snackbarReducer from "./reducers/snackbar";
import devicesReducer from "./reducers/devices";
import screensReducer from "./reducers/screens";
import brandsReducer from "./reducers/brands";
import establishmentsReducer from "./reducers/establishments";
import residencesReducer from "./reducers/residences";
import pageActionsReducer from "./reducers/pageActions";
import userDBReducer from "./reducers/userDB";
import usersReducer from "./reducers/users";
import selectedEstablishmentReducer from "./reducers/selectedEstablishment";
import selectedResidenceReducer from "./reducers/selectedResidence";
import deleteDialogReducer from "./reducers/deleteDialog";
import packsReducer from "./reducers/packs";
import deviceBrandsReducer from "./reducers/deviceBrands";
import deviceTypesReducer from "./reducers/deviceTypes";
import zonesReducer from "./reducers/zones";
import selectedZoneReducer from "./reducers/selectedZone";
import indexReadingsReducer from "./reducers/indexReadings";
import sidebarCollapsedReducer from "./reducers/sidebarCollapsed";

export const store = configureStore({
  reducer: {
    brands: brandsReducer,
    deleteDialog: deleteDialogReducer,
    deviceBrands: deviceBrandsReducer,
    deviceTypes: deviceTypesReducer,
    devices: devicesReducer,
    establishments: establishmentsReducer,
    indexReadings: indexReadingsReducer,
    isMobile: isMobileReducer,
    packs: packsReducer,
    pageActions: pageActionsReducer,
    pageTitle: pageTitleReducer,
    packId: packIdReducer,
    residences: residencesReducer,
    screens: screensReducer,
    selectedEstablishment: selectedEstablishmentReducer,
    selectedResidence: selectedResidenceReducer,
    snackbar: snackbarReducer,
    themeMode: themeModeReducer,
    userDB: userDBReducer,
    users: usersReducer,
    zones: zonesReducer,
    selectedZone: selectedZoneReducer,
    sidebarCollapsed: sidebarCollapsedReducer,
  },
});
